<template>
  <div>
    <div v-if="isLoading" class="stopUserEvents"></div>
    <b-modal v-model="modalShow" hide-header hide-footer @hidden="onHidden" centered hide-backdrop size="sm"
    ref="modalAuth" no-close-on-backdrop :no-close-on-esc="isLoading"
    :modal-class="isStageAuth ? 'stage-auth-modal' : ''">
      <button type="button" aria-label="Close" class="close" @click="$refs.modalAuth.hide()">×</button>
      <form @submit.prevent="submit">
        <slot></slot>
        <vue-hcaptcha 
          sitekey="b85cfc10-e4ff-42d5-97c7-b696def851fb"
          ref="invisibleHcaptcha"
          size="invisible"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
          @error="onCaptchaError">
        </vue-hcaptcha>
      </form>
    </b-modal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { SET_ROUTEBACK } from '../store/actions/otherConst';
  import {
    AUTH_LOGOUT,
    AUTH_REQUEST,
    USER_CHANGE_PASSWORD,
    USER_RESET_EMAIL,
    USER_RESET_PASSWORD
  } from '../store/actions/userConst'
  import { USER_REGISTER } from '../store/actions/userConst'
  import swal from 'sweetalert2'
  import VueHcaptcha from './Hcaptcha';

  export default {
    components: { VueHcaptcha },
    props: {
      modalType: '',
      data: {},
    },
    data() {
      return {
        modalShow: true,
        currentModal: '',
      }
    },
    computed: {
      isStageAuth() {
        return this.modalType === 'login' || this.modalType === 'register';
      },
      ...mapGetters(['routeBack', 'isLoading', 'isLogin'])
    },
    methods: {
      onCaptchaVerified(recaptchaToken) {
        if (this.currentModal === 'login') {
          this.$store.dispatch(AUTH_REQUEST, Object.assign(this.data, {recaptchaToken: recaptchaToken}))
            .then(resp => {
              console.log(resp)
              this.$router.push({name: 'search'})
            })
            .catch(err => {
              this.$refs.invisibleHcaptcha.reset();
              console.log(err)
              const code = this.$ObjValidate(() => err.response.data.error.code) ? err.response.data.error.code : '';
              switch (code) {
                case 'LOGIN_FAILED_EMAIL_NOT_VERIFIED':
                  swal({
                    type: 'error',
                    text: this.$t('text15'),
                    keydownListenerCapture: true,
                    allowOutsideClick: false
                  })
                  break
                case 'LOGIN_FAILED':
                  swal({
                    type: 'error',
                    text: this.$t('loginIncorrect'),
                    keydownListenerCapture: true,
                    allowOutsideClick: false
                  })
                  break
                default:
                  swal({
                    type: 'error',
                    text: this.$t('text16'),
                    keydownListenerCapture: true,
                    allowOutsideClick: false
                  })
                  break
              }
            });
        } else if (this.currentModal === 'register') {
          // default selection for user category
          if (this.data.userType === 'artist') {
            this.data.userCategory = 'artist';
          } else if (this.data.userType === 'agent') {
            this.data.userCategory = 'employer';
          }
          this.$store.dispatch(USER_REGISTER, Object.assign(this.data, {recaptchaToken: recaptchaToken}))
            .then(() => {
              swal({
                type: 'success',
                text: this.$t('text17'),
                keydownListenerCapture: true,
                allowOutsideClick: false
              }).then(()=>this.$router.push({name: 'home'}))
            })
            .catch((err) => {
              this.$refs.invisibleHcaptcha.reset();
              console.log(err)
              const message = this.$ObjValidate(() => err.response.data.error.message) ? err.response.data.error.message : '';
              if (~message.indexOf('Email already exists')) {
                swal({
                  type: 'error',
                  text: this.$t('text18'),
                  keydownListenerCapture: true,
                  allowOutsideClick: false
                });
              } else {
                const code = this.$ObjValidate(() => err.response.data.error.code) ? err.response.data.error.code : '';
                switch (code) {
                  case 'SIMPLE_PASSWORD':
                    swal({
                      type: 'error',
                      text: this.$t('r_password'),
                      keydownListenerCapture: true,
                      allowOutsideClick: false
                    });
                    break;
                  default:
                    swal({
                      type: 'error',
                      text: this.$t('text19'),
                      keydownListenerCapture: true,
                      allowOutsideClick: false
                    });
                    break;
                }
              }
            });
        }
      },
      onCaptchaError(err) {
        console.error('hCaptcha verification failed', err);
        swal({
          type: 'error',
          text: this.$t('captchaUnavailable'),
          keydownListenerCapture: true,
          allowOutsideClick: false,
        });
      },
      onCaptchaExpired() {
        console.log("Expired");
      },
      onHidden() {
        if (this.modalType === 'login' || this.modalType === 'register') {
          if (this.$route.name !== this.modalType) return;
          if (this.routeBack.isBack) {
            this.$store.dispatch(SET_ROUTEBACK, {isBack: false, path: ''});
          }
          this.$router.push({name: 'search'});
          return;
        }
        if (this.routeBack.isBack) {
          this.$store.dispatch(SET_ROUTEBACK, {isBack: false, path: ''})
          this.$router.go(-1);
        } else {
          this.$router.push({name: 'home'});
        }
      },
      submit() {
        switch (this.modalType) {
          case 'login':
            this.currentModal = 'login';
            this.$refs.invisibleHcaptcha.execute().catch(this.onCaptchaError);
            break;
          case 'register':
            if (this.data.password === this.data.passwordConfirm) {
              this.currentModal = 'register';
              this.$refs.invisibleHcaptcha.execute().catch(this.onCaptchaError);
            } else {
              swal({
                type: 'error',
                text: this.$t('text20'),
                keydownListenerCapture: true,
                allowOutsideClick: false
              })
            }
            break;
          case 'reset':
            this.$store.dispatch(USER_RESET_EMAIL, this.data.email)
              .then(() => {
                swal({
                  type: 'success',
                  text: this.$t('text21'),
                  keydownListenerCapture: true,
                  allowOutsideClick: false
                }).then(() => this.$router.push({name: 'home'}))
              })
              .catch(err => {
                const code = this.$ObjValidate(() => err.response.data.error.code) ? err.response.data.error.code : '';
                switch (code) {
                  case 'EMAIL_NOT_FOUND':
                    swal({
                      type: 'error',
                      text: this.$t('text22'),
                      keydownListenerCapture: true,
                      allowOutsideClick: false
                    })
                    break
                  case 'EAUTH':
                    swal({
                      type: 'error',
                      text: this.$t('text23'),
                      keydownListenerCapture: true,
                      allowOutsideClick: false
                    })
                    break
                  case 'RESET_FAILED_EMAIL_NOT_VERIFIED':
                    swal({
                      type: 'error',
                      text: this.$t('text24'),
                      keydownListenerCapture: true,
                      allowOutsideClick: false
                    })
                    break
                  default:
                    swal({
                      type: 'error',
                      text: this.$t('text16'),
                      keydownListenerCapture: true,
                      allowOutsideClick: false
                    })
                    break
                }
              })
            break
          case 'resetPassword':
            if (this.isLogin) {
              this.$store.dispatch(USER_CHANGE_PASSWORD, {
                oldPassword: this.data.password,
                newPassword: this.data.passwordConfirm
              })
                .then(() => {
                  swal({
                    type: 'success',
                    text: this.$t('text25'),
                    keydownListenerCapture: true,
                    allowOutsideClick: false
                  })
                    .then(() => {
                      this.$store.dispatch(AUTH_LOGOUT)
                      this.$router.push({name: 'login'})
                    })
                })
                .catch(err => {
                  const code = this.$ObjValidate(() => err.response.data.error.code) ? err.response.data.error.code : '';
                  switch (code) {
                    case 'INVALID_PASSWORD':
                      swal({
                        type: 'error',
                        text: this.$t('text26'),
                        keydownListenerCapture: true,
                        allowOutsideClick: false
                      })
                      break
                    default:
                      swal({
                        type: 'error',
                        text: this.$t('text16'),
                        keydownListenerCapture: true,
                        allowOutsideClick: false
                      })
                      break
                  }
                })
            } else {
              if (this.data.password === this.data.passwordConfirm) {
                this.$store.dispatch(USER_RESET_PASSWORD, {
                  newPassword: this.data.password,
                  accessToken: this.data.access_token
                })
                  .then(() => {
                    swal({
                      type: 'success',
                      text: this.$t('text27'),
                      keydownListenerCapture: true,
                      allowOutsideClick: false
                    })
                      .then(()=>this.$router.push({name: 'login'}))
                  })
                  .catch(err => {
                    const code = this.$ObjValidate(() => err.response.data.error.code) ? err.response.data.error.code : '';
                    switch (code) {
                      case 'INVALID_TOKEN':
                        swal({
                          type: 'error',
                          text: this.$t('text28'),
                          keydownListenerCapture: true,
                          allowOutsideClick: false
                        })
                        break
                      default:
                        swal({
                          type: 'error',
                          text: this.$t('text16'),
                          keydownListenerCapture: true,
                          allowOutsideClick: false
                        })
                        break
                    }
                  })
              } else {
                swal({
                  type: 'error',
                  text: this.$t('text20'),
                  keydownListenerCapture: true,
                  allowOutsideClick: false
                })
              }
            }
            break
        }
      }
    },
  }
</script>

<style lang="scss">
  .form-control:focus {
    border-color: inherit !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
  }
  .btn-wd {
    min-width: 180px !important;
    background-color: #FB404B !important;
    border-color: #FB404B !important;
    border-radius: 30px !important;
    font-weight: 500 !important;
  }
  .btn-wd:hover {
    background-color: rgb(253, 36, 50) !important;
  }
  .modal-content {
    border-radius: 10px !important;
    background-color: white;
    opacity: 0.8;
  }

  @media (max-height: 565px) {
    .modal{
      margin-top:15%;
    }
  }
  .stopUserEvents {
    position: fixed;
    top: -10000px;
    left: -10000px;
    width: 20000px;
    height: 20000px;
    z-index: 999999;
  }
  .modal.stage-auth-modal {
    margin-top: 0;
  }
  .stage-auth-modal .modal-content {
    background-color: rgba(255, 248, 248, 0.94);
    opacity: 1;
  }
</style>
